import React from "react"

import { Box, Grid, Skeleton } from "@mui/material"
import { Typography } from "@synapse-analytics/synapse-ui"

import styles from "./KonanPageHeader.module.scss"

type Props = {
  title?: string | React.ReactElement
  subtitle?: string | React.ReactElement
  actions?: React.ReactElement[]
  loading?: boolean
}

/**
 * Page header component
 * @param  {string} title page title
 * @param  {string} subtitle page subtitle
 * @param  {React.ReactElement} actions
 * @param  {boolean} loading is page still loading
 * @return {<KonanPageHeader />}
 */
export function KonanPageHeader(props: Readonly<Props>): React.ReactElement {
  const { title, subtitle, actions, loading } = props

  const animation: "wave" | "pulse" = "pulse"

  return (
    <Grid container item direction="row" justifyContent="center" alignItems="flex-start">
      <Grid item xs={12} md={6}>
        <Typography variant="h1-bold">
          {loading ? <Skeleton width={300} animation={animation} className={styles.skeleton} /> : title}
        </Typography>

        {/* Check if undefined to handle case where "" is passed as placeholder */}
        {subtitle !== undefined && (
          <Typography variant="p">
            {loading ? (
              <Box>
                <Skeleton animation={animation} />
                <Skeleton animation={animation} width="40%" />
              </Box>
            ) : (
              subtitle
            )}
          </Typography>
        )}
      </Grid>

      {/* Create actions cell if actions exist*/}
      <Grid item xs={12} md={6}>
        <Grid container justifyContent="flex-end" alignItems="center" gap={1}>
          {actions?.map((action, index) => {
            return (
              <Grid item key={index}>
                {action}
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    </Grid>
  )
}
